import {
    createSelector,
    createFeatureSelector,
    ActionReducerMap,
    MetaReducer
} from '@ngrx/store';
import * as fromRoot from '../../store/app.reducers';
import * as fromOrderCheckout from './order-checkout/order-checkout.reducers';
import * as fromUserDetails from './user-details/user-details.reducers';
import * as fromOrderReferences from './order-references/order-references.reducers';
import * as fromDelivery from './delivery-details/delivery-details.reducers';
import * as fromBilling from './billing-details/billing-details.reducers';

export interface OrderCheckoutState {
    orderInfo: fromOrderCheckout.State;
    userDetails: fromUserDetails.State;
    orderReferences: fromOrderReferences.State;
    deliveryDetails: fromDelivery.State;
    billingDetails: fromBilling.State;
}

export interface State extends fromRoot.AppState {
    orderCheckout: OrderCheckoutState;
}

export const reducers: ActionReducerMap<any> = {
    orderInfo: fromOrderCheckout.reducer,
    userDetails: fromUserDetails.reducer,
    orderReferences: fromOrderReferences.reducer,
    deliveryDetails: fromDelivery.reducer,
    billingDetails: fromBilling.reducer
};

export const metaReducers: MetaReducer<State>[] = [];

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getOrderCheckoutState = createFeatureSelector<OrderCheckoutState>('orderCheckout');
export const getOrderInfoState = createSelector(
    getOrderCheckoutState,
    state => state.orderInfo
);

export const getOrderCheckoutInformation = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getOrderCheckoutInformation
);

export const getSameInvoiceAddressSwitch = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getSameInvoiceAddressSwitch
);

export const isValidOrderInformationSet = createSelector(
    getOrderInfoState,
    fromOrderCheckout.isValidOrderInformationSet
);
export const getValidationStatus = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getValidationStatus
);

export const getCheckoutErrors = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getErrors
);

export const getCheckoutInvalidPage = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getInvalidPage
);

export const getVoucherReference = createSelector(
    getOrderInfoState,
    fromOrderCheckout.getVoucherReference
);

// UserDetails
export const getUserDetailsState = createSelector(
    getOrderCheckoutState,
    state => state.userDetails
);

export const getUserDetails = createSelector(
    getUserDetailsState,
    fromUserDetails.getUserDetails
);

// Order References
export const getOrderReferencesState = createSelector(
    getOrderCheckoutState,
    state => state.orderReferences
);

export const getOrderReferences = createSelector(
    getOrderReferencesState,
    fromOrderReferences.getOrderReferences
);

// Delivery
export const getDeliveryState = createSelector(
    getOrderCheckoutState,
    state => state.deliveryDetails
);

export const getDeliveryAddress = createSelector(
    getDeliveryState,
    fromDelivery.getDeliveryAddress
);

// Billing Details
export const getBillingState = createSelector(
    getOrderCheckoutState,
    state => state.billingDetails
);

export const getBillingDetails = createSelector(
    getBillingState,
    fromBilling.getBillingDetails
);


// localstorage persistence
export const voucherReferenceKey = 'OrderVoucherReference';
export interface VoucherReference {
    id: number | string;
    reference: string;
    dateAdded: number;
    isValid?: boolean;
}
